import { APIClient } from 'cx-api-client-lite';

/**
 * @typedef {function(payload: {}=): Promise<{data: {}, headers: {}, status: Number}>} ApiMethod
 */
/**
 * @typedef {Object} SubscriptionAPIClient
 *
 * @description Use the following prefix in the method naming: POST -> create; GET -> get; DELETE -> delete; PATCH, PUT -> update;
 *
 * @property {ApiMethod} getProducts
 */
/**
 * @type {SubscriptionAPIClient | APIClient}
 */
const Subscription = new APIClient({
  getProducts: {
    path: '/subs/v2/products',
    method: 'GET',
  },
});

export default Subscription;
